import { render, staticRenderFns } from "./yCode.vue?vue&type=template&id=28620cb2&scoped=true"
import script from "./yCode.vue?vue&type=script&lang=js"
export * from "./yCode.vue?vue&type=script&lang=js"
import style0 from "./yCode.vue?vue&type=style&index=0&id=28620cb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28620cb2",
  null
  
)

export default component.exports